<template>
<router-link v-if="current" :class="alias"
:to="{name: 'currentPage', params:{cid: currentId}}">
{{current.label}}
</router-link>
</template>

<script>
export default {
  name: `CurrentTag`,
  props: {
    current: Object,
    base: String
  },
  computed: {
    currentId() {
      if (typeof this.current !== `undefined` && this.current.id) {
        return this.current.id;
      }
      return 1;
    },
    alias() {
      if (typeof this.current.alias !== `undefined`) {
        return this.current.alias;
      }
      return ``;
    }
  }
};
</script>

<style scoped>
a {
  margin-left: 5px;
}
</style>
